import { context, trace, SpanStatusCode } from '@opentelemetry/api';
/**
 * @description Add error to current span
 * @param {Error} error
 * @returns {void}
 */
export var captureException = function (error) {
    if (!error)
        return;
    var span = trace.getSpan(context.active());
    if (!span)
        return;
    span.recordException(error);
    span.setStatus({
        code: SpanStatusCode.ERROR,
        message: error.message,
    });
};
//# sourceMappingURL=capture-exception.js.map